export const productDetailDate = (date: string | Date, timeZone?: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
    ...(timeZone ? { timeZone } : {}),
  }
  let dateString = new Date(date).toLocaleString('en-US', options)
  if (dateString.includes(' at ')) {
    dateString = dateString.replace(' at ', ', ')
  }
  const parts = dateString.split(',').map(p => p.trim())
  const modifiedDate = parts.slice(0, 2).join(', ')
  const modifiedTime = parts[2] ?? ''
  const showModifiedTime = modifiedTime ? `| ${modifiedTime}` : ''
  const fullDateTime = `${modifiedDate} ${showModifiedTime}`
  const commaSeparatedDateTime = `${modifiedDate}, ${modifiedTime}`
  const shortDate = modifiedDate
    .replace(',', '')
    .split(' ')
    .slice(0, 2)
    .join(' ')

  return {
    modifiedDate,
    modifiedTime,
    fullDateTime,
    shortDate,
    commaSeparatedDateTime,
  }
}
